import { REQUIREMENT } from "helpers/constants";
import { Requirement } from "types/requirement";

/**
 * Portal detail path for a requirement, e.g. /requirements/epa/:id
 */
export function getRequirementDetailsPath(
  requirement?: Pick<Requirement, "requirement_id" | "type"> | null,
): string | null {
  if (!requirement?.requirement_id) {
    return null;
  }
  switch (requirement.type) {
    case REQUIREMENT.REQUIREMENT_EPA:
      return `/requirements/epa/${requirement.requirement_id}`;
    case REQUIREMENT.REQUIREMENT_COMPETENCY:
      return `/requirements/competency/${requirement.requirement_id}`;
    case REQUIREMENT.REQUIREMENT_ITER:
      return `/requirements/iter/${requirement.requirement_id}`;
    default:
      return `/requirements/epa/${requirement.requirement_id}`;
  }
}
